module.exports = {
  LSKEY_TOKEN: 'token',
}
